// Tighter than antd's default 24px between form fields, matching the 16px used
// between the other elements in the sign-in card (as on Tracer's login page).
export const FORM_THEME = { components: { Form: { itemMarginBottom: 16 } } }
